<template>
  <div class="Layout-container">
    <div class="Layout-head" :style="{'height':height}">
         <!-- <div class="Mask"></div>  -->
         <div class="Layout-bj" :style="{'backgroundImage':'url(' + imgsrc + ')'}"></div>
        <div class="head-txt"> 
        <p class="title">{{title}}</p>
        <p class="content" v-if="content">{{content}}</p> 
        </div>
       <div class="Layout-body">
        <slot/>
        </div>
    </div>
    
  </div>
</template>

<script>
import imgsrc from '@/assets/数字镖局bj.jpg'
export default {
props:{
    height:{
        type:String
        ,default:'500px'
    },
    title:{
        type:String,
        required:true

    }
    ,content:{
        type:String,
    },
    imgsrc:{
        default:imgsrc
    },
    filter:{
        type:Number,
        default:9
    }
}
,created(){
    console.log(this.imgsrc);
    
}
}
</script>

<style scoped>
.Layout-container{
    margin: 0;
}
.Layout-bj{
    width: 100%;
    height: 100%;
 
 background-size:cover;
    background-repeat:no-repeat;
     z-index: 1;
}
.Layout-head{
    min-width: 1920px;
    height: 520px;
    
    position: relative;
}

.head-txt{
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%,-50%);
    text-align: center;
    color: #fff;
    z-index: 3;
}
.title{
    font-family: Heavy;
font-weight: 800;
font-size: 48px;
color: #FFFFFF;
line-height: 65px;

   letter-spacing: 1px;

   margin-bottom: 17px;
}
.content{
    font-family: Light;
font-weight: 300;
font-size: 24px;
color: #FFFFFF;
line-height: 46px;
     letter-spacing: 2px;
}
.Layout-body{
   
    border-radius:20px;
    position: absolute;
    bottom: 0;left: 50%;
    transform: translate(-50%,50%);
    background-color: #fff;
    z-index: 4;
     box-shadow: 0px 1px 2px rgba(0, 0, 0, .4);
}
</style>